import { useIsFeatureEnabled } from '../../../api/features/features';
import { Pillar2DebugEnabled, Pillar2Enabled } from '../../../utils/FeatureFlags.constants';

export const usePillar2FeatureFlag = () => {
    const { data: isPillar2Enabled, isLoading: isPillar2Loading } = useIsFeatureEnabled({
        featureFlagName: Pillar2Enabled,
    });

    const { data: isPillar2DebugEnabled, isLoading: isPillar2DebugLoading } = useIsFeatureEnabled({
        featureFlagName: Pillar2DebugEnabled,
    });

    return {
        isPillar2Enabled: !!isPillar2Enabled,
        isPillar2DebugEnabled: !!isPillar2DebugEnabled,
        isLoading: isPillar2Loading || isPillar2DebugLoading,
    };
};
